import React from "react";
import { siteData, navLinks } from "../data/mock";
import { Separator } from "./ui/separator";
import { ArrowUp, Instagram } from "lucide-react";

export const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const scrollToSection = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ background: "#ffffff" }} className="pt-12 md:pt-24 pb-8">
      <div className="max-w-[87.5rem] mx-auto px-10">
        {/* Top Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 mb-10 md:mb-16">
          {/* Brand */}
          <div>
            <img
              src="/BTL-colour.svg"
              alt="Built to Lead"
              className="h-12 w-auto mb-4"
            />
            <p
              className="text-[#6b7280] text-sm font-medium leading-relaxed mb-6"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {siteData.tagline}
            </p>
            <p
              className="text-[#6b7280] text-xs font-medium uppercase tracking-[0.15em]"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              A {siteData.brand} Event
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-[#6b7280] text-xs font-medium uppercase tracking-[0.2em] mb-6"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollToSection(link.href)}
                  className="text-left text-[#1f2937] bg-transparent border-none text-sm font-medium cursor-pointer transition-colors duration-300 hover:text-[#FE3A80] p-0"
                  style={{ fontFamily: "'Inter', Arial, sans-serif" }}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Event Info */}
          <div>
            <h4
              className="text-[#6b7280] text-xs font-medium uppercase tracking-[0.2em] mb-6"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              Event Details
            </h4>
            <div className="space-y-3">
              <p className="text-[#1f2937] text-sm font-medium" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {siteData.date}
              </p>
              <p className="text-[#1f2937] text-sm font-medium" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {siteData.time}
              </p>
              <a
                href="https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUqDQgBEC4YrwEYxwEYgAQyCggAEEUYFhgeGDkyDQgBEC4YrwEYxwEYgAQyBwgCEAAYgAQyBwgDEAAYgAQyCAgEEAAYFhgeMggIBRAAGBYYHjIICAYQABgWGB4yCAgHEAAYFhgeMggICBAAGBYYHtIBCDM1OTFqMGo3qAIAsAIA&um=1&ie=UTF-8&fb=1&gl=ca&sa=X&geocode=KQEAAASqBc5MMe-h3NlgfxTY&daddr=245+Centrum+Blvd,+Orl%C3%A9ans,+ON+K1E+0A1"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1f2937] text-sm font-medium underline hover:text-[#FE3A80] transition-colors"
                style={{ fontFamily: "'Inter', Arial, sans-serif" }}
              >
                {siteData.location}
              </a>
            </div>
            <a
              href="https://shenkmanarts.ca/en/built-to-lead"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-3 mt-6 text-sm font-semibold uppercase no-underline cursor-pointer transition-all duration-300 hover:scale-[1.03] active:scale-[0.98]"
              style={{
                fontFamily: "'Montserrat', Arial, sans-serif",
                letterSpacing: "0.1em",
                background: "#FE3A80",
                color: "#ffffff",
                border: "none",
              }}
            >
              View Event
            </a>
          </div>
        </div>

        <Separator className="bg-[#e5e7eb] mb-8" />

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <p
              className="text-[#6b7280] text-xs font-medium"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              &copy; {new Date().getFullYear()} Walker Ottawa. All rights reserved.
            </p>
            <a
              href="https://instagram.com/builttoleadottawa"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-8 h-8 rounded-full border border-[#E1306C] text-[#E1306C] transition-all duration-300 hover:bg-[#E1306C] hover:text-white"
            >
              <Instagram size={15} />
            </a>
          </div>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 bg-transparent border border-[#e5e7eb] rounded-full px-4 py-2 text-[#6b7280] cursor-pointer transition-all duration-300 hover:border-[#FE3A80] hover:text-[#FE3A80]"
          >
            <ArrowUp size={14} />
            <span className="text-xs font-medium uppercase tracking-wider" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              Back to Top
            </span>
          </button>
        </div>
      </div>
    </footer>
  );
};
